// import FingerprintJS from '@fingerprintjs/fingerprintjs'
// const inBrowser = () => typeof window !== 'undefined'

export default function() {
  // if (!inBrowser()) {
  return Promise.resolve('non-browser-fingerprint')
  // }
  // const exec = function(resolve) {
  //   FingerprintJS.then(_ => FingerprintJS.load())
  //     .then(fp => fp.get())
  //     .then(result => {
  //       resolve(result.visitorId)
  //     })
  // }
  // return new Promise((resolve, reject) => {
  //   try {
  //     if (window.requestIdleCallback) {
  //       requestIdleCallback(() => exec(resolve))
  //     }
  //     else {
  //       setTimeout(() => exec(resolve), 500)
  //     }
  //   }
  //   catch (err) {
  //     const error = new Error(`Error generating Browser fingerprint: ${err.message}`)
  //     reject(error)
  //   }
  // })
}
